export function formatDate(dateString) {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();
    return { day, month, year };
}
export function formatStringDate(inputDate) {
    var parts = inputDate.split('/');
    var day = parts[0];
    var month = parts[1];
    var year = parts[2];
    return year + '-' + month + '-' + day;
}
export function dateDiffInDays(date1, date2) {
    const utcDate1 = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());
    const utcDate2 = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());
    const timeDiff = utcDate2 - utcDate1;
    const daysDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    return daysDiff;
}
export function diffYears(dt2, dt1) {
    var diff = (dt2.getTime() - dt1.getTime()) / 1000;
    diff /= (60 * 60 * 24);
    return Math.abs(Math.round(diff / 365.25));
}

export function convertDate(date) {
    const parsedDate = new Date(date);
    return parsedDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
}

export function formattedDateRange(startDate, endDate, locale) {
    return `${startDate.toLocaleDateString(undefined, { day: 'numeric' })} - ${endDate.toLocaleDateString('en-US', { day: 'numeric' })} ${endDate.toLocaleDateString(locale=='ar'?'ar-US':'en-US', { month: 'long' })} ${endDate.toLocaleDateString('en-US', { year: 'numeric' })}`;
}
export function frCaDateFormat(date) {
    var dateObject = new Date(date);
    const formattedDate = dateObject.toLocaleDateString('fr-CA', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    });
    return formattedDate;
}
export function addDaysToDate(date, days) {
    var dateObject = new Date(date);
    dateObject.setDate(dateObject.getDate() + parseInt(days));
    const formattedDate = dateObject.toLocaleDateString('fr-CA', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    });
    return formattedDate;
}
export function decreaseDayFromDate(date) {
    const dateObject = new Date(date);
    dateObject.setDate(dateObject.getDate() - 1);
    const formattedDate = dateObject.toLocaleDateString('fr-CA', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    });
    return formattedDate;
}
export function needAnExtraDayAtBeginning(date, time, time_allowed_entry_before_booking) {
    var date1 = date.toLocaleDateString('en-US', {
        year: 'numeric'
    }) + '-' + date.toLocaleDateString('en-US', {
        month: '2-digit'
    }) + '-' + date.toLocaleDateString('en-US', {
        day: '2-digit'
    });
    const startTime = new Date(date);
    startTime.setHours(startTime.getHours() + time_allowed_entry_before_booking);
    const endTime = new Date(`${date1}T${time}`);
    const timeDifference = endTime - startTime;
    const hoursDifference = timeDifference / (1000 * 60 * 60);
    return hoursDifference > 0 ? true : false;
}
export function needAnExtraDayAtEnd(date1, date2) {
    var date1 = new Date(date1),
        date2 = new Date(date2);
    const utcDate1 = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());
    const utcDate2 = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());
    const timeDiff = utcDate2 - utcDate1;
    const daysDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    return daysDiff > 0 ? true : false;
}
export function countExtraDayAtEnd(date1, date2) {
    var date1 = new Date(date1),
        date2 = new Date(date2);
    const utcDate1 = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());
    const utcDate2 = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());
    const timeDiff = utcDate2 - utcDate1;
    const daysDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    return daysDiff;
}